import React from 'react';

import styled from 'styled-components';

import AttachmentFileIcon from 'common/Icons/AttachmentFileIcon';
import { CommunityActivityAttachmentType } from 'types/communities';

type ActivityAttachmentsProps = {
  attachments: CommunityActivityAttachmentType[];
};

const Attachments = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

const AttachmentLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  color: var(--dark-blue);
  font-size: 12px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const AttachmentIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: var(--text-secondary);
  font-size: 15px;
`;

const AttachmentName = styled.span`
  display: inline-block;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
`;

const ActivityAttachments = ({ attachments }: ActivityAttachmentsProps) => {
  if (attachments.length === 0) {
    return null;
  }

  return (
    <Attachments>
      {attachments.map((attachment) => (
        <AttachmentLink
          href={attachment.file_url}
          key={attachment.id}
          target="_blank"
          rel="noopener noreferrer"
          title={attachment.file_name}
        >
          <AttachmentIcon>
            <AttachmentFileIcon fileExtension={attachment.file_extension} />
          </AttachmentIcon>
          <AttachmentName>{attachment.file_name}</AttachmentName>
        </AttachmentLink>
      ))}
    </Attachments>
  );
};

export default ActivityAttachments;
